module.exports = __webpack_public_path__ + "img/logo-recicla.d4b72be6.png";